// Validated against the dataviz skill's CVD/contrast checks (see scripts/validate_palette.js):
// red (brand primary) + blue passes all checks; a true gray fails the chroma-floor check
// and can't be used as a second categorical series.
export const CHART_COLORS = {
  primary: '#DC2626', // registrations / single-series marks
  secondary: '#2A78D6', // hires / second series
  grid: '#e1e0d9', // hairline gridlines
  axis: '#898781', // axis ticks/labels
  ink: 'rgba(23,20,27,0.03)', // hover cursor tint
  tooltipLabel: '#898781', // muted tooltip heading
  tooltipValue: '#0b0b0b', // primary ink for tooltip values
  legend: '#52514e', // secondary ink for legend/label text
};

// Blue ordinal ramp (dataviz skill's documented sequential steps, light mode) —
// for ordered categories like a pipeline funnel, darkest→lightest so visual
// weight tracks the falling volume down the funnel. The lightest step used
// (250) is the documented floor that still clears 2:1 contrast on white.
const ORDINAL_STEPS = [
  '#0d366b',
  '#104281',
  '#184f95',
  '#1c5cab',
  '#256abf',
  '#2a78d6',
  '#3987e5',
  '#5598e7',
  '#6da7ec',
  '#86b6ef',
];

export function ordinalRamp(count) {
  if (count <= 1) return [ORDINAL_STEPS[4]];
  const last = ORDINAL_STEPS.length - 1;
  return Array.from({ length: count }, (_, i) => ORDINAL_STEPS[Math.round((i / (count - 1)) * last)]);
}
